import type { RNGConfig } from "./RNGConfig.type"
import tmpRng from "./tmpRng"

export default function tmpRngWith (seed: number) : RNGConfig {
  tmpRng.seed = seed
  tmpRng.state = seed
  return tmpRng
}